import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState, AppThunk } from "../../app/store";
import { fetchMessages } from "./messagesAPI";

export interface MessageState {
  messages: Array<any>;
  status: "idle" | "loading" | "failed";
}

const initialState: MessageState = {
  messages: [],
  status: "idle",
};

export const GetMessages = createAsyncThunk(
  "message/fetchMessages",
  async () => {
    const response = await fetchMessages();
    return response;
  }
);

export const messageSlice = createSlice({
  name: "message",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(GetMessages.pending, (state) => {
        state.status = "loading";
      })
      .addCase(GetMessages.rejected, (state, action) => {
        state.status = "failed";
      })
      .addCase(GetMessages.fulfilled, (state, action) => {
        state.status = "idle";
        state.messages =  action.payload.messages;
      });
  },
});

export const {} = messageSlice.actions;

export const selectMessages = (state: RootState) => {
  return state.message.messages;
};

export default messageSlice.reducer;
